import React, { useContext } from 'react';
import SkpSelect from 'atomic/form/select';
import { TeApiContext } from '@ecommerce/nest-ssr/common';

import './product-opinion-filters.scss';

interface ProductOpinionFiltersProps {
    params: {
        rating: number;
        sort: string;
    };
    onFilter: (value: number) => void;
    onSort: (value: string) => void;
}

const ProductOpinionFilters: React.FC<ProductOpinionFiltersProps> = ({ onFilter, onSort, params }) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    return (
        <div className="product-opinions-filters">
            <SkpSelect
                name="rating"
                label="Ilość gwiazdek:"
                options={[
                    { value: 0, label: 'Wszystkie' },
                    { value: 1, label: '1' },
                    { value: 2, label: '2' },
                    { value: 3, label: '3' },
                    { value: 4, label: '4' },
                    { value: 5, label: '5' }
                ]}
                hideSelectedOptions={false}
                small={true}
                defaultValue={params.rating}
                className="product-opinions-filters--select"
                viewType={api.getDevice() !== 'mobile' ? 'transparent' : 'select'}
                onChange={onFilter}
            />
            <SkpSelect
                name="sort"
                label="Sortuj:"
                options={[
                    { value: '', label: 'Od najnowszych' },
                    { value: 'likes', label: 'Od najbardziej pomocnych' }
                ]}
                hideSelectedOptions={false}
                defaultValue={params.sort}
                small={true}
                className="product-opinions-filters--select"
                viewType={api.getDevice() !== 'mobile' ? 'transparent' : 'select'}
                onChange={onSort}
            />
        </div>
    );
};

export default ProductOpinionFilters;
